import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import {
  BaseWebsocketMessage,
  SubWebsocketMessageRequest,
  WebsocketEntTypes,
  WebSocketService,
  WSEntityManager,
} from '@qtek/core/websockets-core';
import {
  DocumentTemplate,
  TEMPLATE_TYPE_API_VALUE,
  TemplateTypes,
} from '@qtek/shared/models';
import { Observable } from 'rxjs';
import { HttpEntityManager } from '../http-entity-manager';

@Injectable({
  providedIn: 'root',
})
export class TemplatesService extends HttpEntityManager<
  DocumentTemplate,
  DocumentTemplate
> {
  protected http = inject(HttpClient);
  private webSocketService = inject(WebSocketService);

  constructor() {
    super();
  }

  entityName: WebsocketEntTypes = 'Template';
  wsManager = new WSEntityManager(this.webSocketService, this.entityName);

  readonly webSocketIsAlive$ = this.webSocketService.getWebSocketIsAlive$();

  subscribe(
    payload: Omit<SubWebsocketMessageRequest, 'ent' | 'op'>
  ): Observable<BaseWebsocketMessage> {
    return this.wsManager.subscribeEntity({ ...payload }, true);
  }

  createTemplate(templateName: string, templateType: TemplateTypes): void {
    this.wsManager.create({
      res: { name: templateName, type: TEMPLATE_TYPE_API_VALUE[templateType] },
    });
  }

  updateTemplate(templateName: string, templateId: string): void {
    this.wsManager.update({
      res: { name: templateName },
      id: templateId,
    });
  }

  deleteTemplate(templateId: string): void {
    this.wsManager.delete({ id: templateId });
  }
}
